import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Lock: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99997 3C6.8954 3 5.99997 3.89543 5.99997 5V6H9.99997V5C9.99997 3.89543 9.10454 3 7.99997 3ZM3.99997 5V6H3.5C2.67157 6 2 6.67157 2 7.5V13.5C2 14.3284 2.67157 15 3.5 15H12.5C13.3284 15 14 14.3284 14 13.5V7.5C14 6.67157 13.3284 6 12.5 6H12V5C12 2.79086 10.2091 1 7.99997 1C5.79083 1 3.99997 2.79086 3.99997 5ZM8 11.75C8.69036 11.75 9.25 11.1904 9.25 10.5C9.25 9.80964 8.69036 9.25 8 9.25C7.30964 9.25 6.75 9.80964 6.75 10.5C6.75 11.1904 7.30964 11.75 8 11.75Z"
      fill="currentColor"
    />
  </svg>
);
